<script setup lang="ts">
import { ref } from "vue"
import AppButton from "@/components/ui-kit/button/AppButton.vue"
import { useConfirmKeys } from "@/composables/useConfirmKeys"

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})
</script>

<template>
	<div ref="$root" class="move-all-confirm">
		<div class="move-all-confirm__title">{{ $t('notifications_move_all_title') }}</div>
		<div class="move-all-confirm__description">
			{{ $t('notifications_move_all_question') }}
		</div>
		<div class="move-all-confirm__actions">
			<app-button
				class="move-all-confirm__actions-button"
				type="secondary"
				:label="$t('cancel_short')"
				@click="emit('cancel')"
			/>
			<app-button
				class="move-all-confirm__actions-button"
				:label="$t('confirm_short')"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.move-all-confirm {
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
